import { CSSProperties, FC } from 'react'

import { IconArrowInbox, Button, Tooltip } from '@sequencehq/core-components'

import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { filenameFromResponse } from '@sequencehq/utils'
import { useRemoteQuotePdfDownload } from '@sequencehq/quote-content'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const ButtonDownloadQuotePdf: FC<{
  style?: CSSProperties
  'data-testid'?: string
}> = ({ style, 'data-testid': dataTestId }) => {
  const ctx = useCubeContext()

  const quoteId = ctx.queries.rawData.data.common.id
  const quoteNumber = ctx.queries.rawData.data.quote.quoteNumber
  const pdfStatus = ctx.queries.rawData.data.quote.pdfStatus

  const disabled: boolean = !['GENERATED', 'NOT_YET_REQUESTED'].includes(
    pdfStatus
  )

  const label = disabled ? 'PDF not ready' : 'Download quote PDF'

  const { onClick: downloadOnClick } = useRemoteQuotePdfDownload({
    fileName: res => filenameFromResponse(res, `${quoteNumber}.pdf`),
    downloadPdfEndpoint: () =>
      dashboardv20240509Client.downloadQuotePdf({ id: quoteId })
  })

  return (
    <Tooltip label={label}>
      <Button
        variant="secondary"
        icon={<IconArrowInbox color="inherit" />}
        aria-label={label}
        disabled={disabled}
        onClick={downloadOnClick}
        style={style}
        data-testid={dataTestId}
      />
    </Tooltip>
  )
}
